import {
    UNITS_REBUILD_REQUEST,
    UNITS_REBUILD_ERROR,
    UNITS_REBUILD_SUCCESS,
} from 'state/actions/unit_rebuild'

const initialState = {
    inProgress: false,
    errorMessage: '',
}

export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
    case UNITS_REBUILD_REQUEST: {
        return {
            ...state,
            inProgress: true,
            errorMessage: '',
        }
    }
    case UNITS_REBUILD_ERROR: {
        return {
            ...state,
            inProgress: false,
            errorMessage: action.payload.errorMessage,
        }
    }
    case UNITS_REBUILD_SUCCESS: {
        return {
            ...state,
            inProgress: false,
            errorMessage: '',
        }
    }
    default:
        return state
    }
}



// WEBPACK FOOTER //
// ./state/reducers/units/unit_rebuild.js